import React from 'react';
import PropTypes from 'prop-types';
// gallery
import PopupMeta from '../media/PopupMeta';
import TextField from 'material-ui/TextField';
// player
import Player from '../player/Player';
//
import IconEdit from 'material-ui/svg-icons/editor/mode-edit';
import IconRemove from 'material-ui/svg-icons/navigation/close';
import {staticUrl} from '../../lib/config';
import {colors} from '../../lib/styles';
import './preview.css';

const propTypes = {
    // тип превью — по всей ширине, или маленькое
    type: PropTypes.string,
    // высота превью
    height: PropTypes.number,
    // петь для превью файла
    item: PropTypes.string.isRequired,
    // id превью файла
    mediaId: PropTypes.string,
    // аттрибуты превью
    attr: PropTypes.string,
    // возвращение данных по поисанию родителю
    setPreviewAttr: PropTypes.func,
    // удаление превью
    removePreview: PropTypes.func,
    // отображать поле для аттрибутов
    showAttr: PropTypes.bool
};

const defaultProps = {
    type: 'full',
    showAttr: false,
    height: 450,
    setPreviewAttr: () => {
    },
    removePreview: () => {
    }
};

class Preview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openPreviewEdit: false,
            attr: props.attr
        }
    }
    
    render() {
        const {height} = this.props;
        const previewPath = this.props.item;
        const isVideo = (previewPath.indexOf('.mp4') !== -1);
        const wrapperClassName = this.props.type === 'full' ? 'preview' : 'preview is-small';
        const imgClassName = this.props.type === 'full' ? 'preview--img_full' : 'preview--img_small';
        const btnWrapperClassName = this.props.type === 'full'
            ? 'preview--btn-wrapper preview--btn-wrapper_header'
            : 'preview--btn-wrapper preview--btn-wrapper_float';
        if (previewPath) {
            return (
                <div className={wrapperClassName}>
                    <div className="preview--media-item">
                        {this.state.openPreviewEdit && this.props.mediaId && <PopupMeta
                            id={this.props.mediaId}
                            closeDialogHandle={() => {
                                this.setState({openPreviewEdit: false})
                            }}
                        />}
                        {isVideo && (
                            <Player
                                style={{
                                    width: '100%',
                                    height
                                }}
                                config={{
                                    sources: [{src: `${staticUrl}/${previewPath}`, type: 'video/mp4'}],
                                    autoplay: false
                                }}/>
                        )}
                        {!isVideo && <img src={`${staticUrl}/${previewPath}`} className={imgClassName} alt="preview"/>}
                        <div className={btnWrapperClassName}>
                            {this.props.mediaId && <IconEdit
                                className="preview--btn-item"
                                onClick={() => {
                                    this.setState({openPreviewEdit: true});
                                }}
                                color={colors.button}
                                hoverColor={colors.linkHover}/>}
                            <IconRemove
                                className="preview--btn-item"
                                onClick={() => {
                                    this.props.removePreview();
                                }}
                                color={colors.button}
                                hoverColor={colors.linkHover}/>
                        </div>
                    </div>
                    {this.props.showAttr && <TextField
                        hintText="Описание превью"
                        floatingLabelText="Описание превью"
                        value={this.state.attr || ''}
                        fullWidth={true}
                        onChange={(e, v) => {
                            this.props.setPreviewAttr(v);
                            this.setState({attr: v});
                        }}
                        floatingLabelFixed={true}
                    />}
                </div>
            )
        }
        return <div/>;
    }
}

Preview.propsTypes = propTypes;
Preview.defaultProps = defaultProps;

export default Preview;


// WEBPACK FOOTER //
// src/components/preview/Preview.js